<template>
  <AppPhoneField :value="model.$model"
                 :label="label"
                 :error-messages="telephoneErrors"
                 hide
                 @on-input="handlePhoneChange"
  />
</template>

<script>
import { parsePhoneNumber } from 'awesome-phonenumber'

import AppPhoneField from '@/common/AppPhoneField.vue'
import i18n from '@/plugins/i18n'

export default {
  name: 'Telephone',
  components: { AppPhoneField },
  props: {
    label: {
      type: String,
      default: i18n.global.t('common.phoneNumber'),
    },
    model: {
      type: Object,
      required: true,
    },
  },
  emits: ['phone-validation-change'],
  data () {
    return {
      isValidPhoneNumber: false,
      isMobilePhoneNumber: false,
    }
  },
  computed: {
    telephoneErrors () {
      const errors = []
      if (!this.model.required.$response) {
        return [this.$t('common.validations.fieldRequired', { fieldName: this.label })]
      }
      !this.isValidPhoneNumber && errors.push(this.$t('common.identity-checking.IdentityCheckingInformation.errors.invalidPhoneNumber'))
      !this.isMobilePhoneNumber && errors.push(this.$t('common.identity-checking.IdentityCheckingInformation.errors.invalidMobilePhoneNumber'))

      return errors
    },
  },
  methods: {
    handlePhoneChange (input, originalEvent) {
      const numberToCheck = originalEvent.number || input
      const event = parsePhoneNumber(numberToCheck)
      this.isValidPhoneNumber = event.valid
      // In some countries it's possible to upgrade a fixed line number to a mobile line
      // It's the case in Canada or the US for example (See V2-3466)
      // Hence event.type === 'fixed-line-or-mobile'
      // so we don't restrict those cases
      this.isMobilePhoneNumber = event.type === 'mobile' || event.type === 'fixed-line-or-mobile'
      this.$emit('phone-validation-change', this.isValidPhoneNumber && this.isMobilePhoneNumber)

      this.model.$model = event.number.e164 || input
    },
  },
}
</script>
